const STORAGE_KEY = 'mhp.lastPatientImportReport';

export function saveLastImportReport(report) {
  if (!report) return null;
  const payload = {
    ...report,
    importedAt: report.importedAt || new Date().toISOString(),
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // ignore quota / private mode
  }
  return payload;
}

export function loadLastImportReport() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearLastImportReport() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function formatImportReportSummary(report) {
  if (!report) return 'No import yet';
  const when = report.importedAt ? new Date(report.importedAt).toLocaleString() : 'unknown time';
  const file = report.fileName || 'file';
  const mode = report.duplicateMode || 'Skip';
  return `${file} · ${when} · ${mode} · patients +${report.created || 0}/~${report.updated || 0} · devices +${report.devicesCreated || 0}`;
}
